import { render, staticRenderFns } from "./splitEmail.vue?vue&type=template&id=fa29f9f2&scoped=true"
import script from "./splitEmail.vue?vue&type=script&lang=js"
export * from "./splitEmail.vue?vue&type=script&lang=js"
import style0 from "./splitEmail.vue?vue&type=style&index=0&id=fa29f9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa29f9f2",
  null
  
)

export default component.exports